import Vue from 'vue'
import http from '@/services/http.service'

// 各コンポーネントからアクセスするときの名前登録（テンプレ）
Vue.mixin({
  beforeCreate() {
    const options = this.$options
    if (options.supplier) this.$supplier = options.supplier
    else if (options.parent && options.parent.$supplier)
      this.$supplier = options.parent.$supplier
  },
})

export default {
  /**
   * キーワードで取得
   */
  async getByKeyWord(keyword) {
    try {
      const response = await http.get(`/suppliers?keyword=${keyword}`)
      return response.data
    } catch (error) {
      if (error.response.status === 404) {
        return undefined
      } else {
        throw error
      }
    }
  },
  /**
   * コードで取得
   */
  async getByCode(codes) {
    const response = await http.get(`/suppliers?codes=${codes.join(',')}`)
    return response.data
  },
}
